import { IKimAddress } from '@alberta/konexi-shared';

/**
 * Display labels for the organization's own KIM addresses.
 *
 * The KIM address itself stays the identifying value that is stored on the user
 * (see IUser.kimAddresses / IUser.kimMailboxAddresses) — the display name is
 * presentation only and is resolved from the organization catalog on read.
 */

/** Builds `Wundzentrum Nord (wz@kim.telematik)`, or the bare address when no display name is configured. */
export function buildKimAddressLabel(organizationKimAddress: IKimAddress): string {
  const name = organizationKimAddress.name?.trim();
  return name ? `${name} (${organizationKimAddress.kimAddress})` : organizationKimAddress.kimAddress;
}

/** Resolves the label for a stored KIM address; falls back to the bare address when it is not in the catalog. */
export function resolveKimAddressLabel(kimAddress: string, organizationKimAddresses: IKimAddress[]): string {
  const organizationKimAddress = organizationKimAddresses.find(entry => entry.kimAddress === kimAddress);
  return organizationKimAddress ? buildKimAddressLabel(organizationKimAddress) : kimAddress;
}
